import React, { Suspense } from "react";
import OrderHistorySectionCard from "@/features/my-order/features/order-history/components/OrderHistorySectionCard";
import OrderHistoryButton from "@/features/my-order/features/order-history/components/OrderHistoryButton";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import OrderHistoryClaimContent from "@/features/my-order/features/order-history/components/claim-section/OrderHistoryClaimContent";
import { useClaimModalStore } from "@/features/my-order/features/order-history/stores/useClaimModalStore";
import OrderHistoryClaimModal from "../../features/claim/components/OrderHistoryClaimModal";

function OrderHistoryClaimSection() {
  const { onOpen: onClaimModalOpen } = useClaimModalStore();
  const { tTitle } = useI18nHelper();
  return (
    <OrderHistorySectionCard
      titleKey={"order_history:claim.claim_info"}
      iconSrc={"head-set"}
      actions={
        <OrderHistoryButton onClick={onClaimModalOpen}>
          {tTitle("order_history:claim.request_claim")}
        </OrderHistoryButton>
      }
    >
      <OrderHistoryClaimContent />
    </OrderHistorySectionCard>
  );
}

export default OrderHistoryClaimSection;
